import { Badge } from '@material-ui/core'
import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useAppHeaderNotificationStyles } from './app-header-notification.styles'
import { UserNotification } from '../../store/notifications/types'
import { useHeaderNotification } from './app-header-notification.hook'
import { setBundleDrawerOpen } from '../../store/notifications/reducer'

export const AppHeaderNotification = (): React.ReactElement => {
  const classes = useAppHeaderNotificationStyles()
  const dispatch = useDispatch()
  const [orderLabelNotifications] = useState<UserNotification[]>([])
  const { notifications } = useHeaderNotification()

  const handleClick = () => {
    dispatch(setBundleDrawerOpen(true))
  }

  const isVisibleBadge =
    notifications.filter(
      (notification: UserNotification) => !notification.reviewed
    ).length > 0 || orderLabelNotifications.length > 0

  // Render Popover
  return (
    <div className={classes.root}>
      {/* Icon Holder */}
      <span
        className={[classes.iconHolder, classes.notificationIcon].join()}
        onClick={handleClick}
      >
        <Badge color="secondary" variant="dot" invisible={!isVisibleBadge}>
          <NotificationsNoneIcon />
        </Badge>
      </span>
    </div>
  )
}
